import z from "zod";

export const StringSchema = z.string();
export type StringDto = z.infer<typeof StringSchema>;

export const NullableStringSchema = z.string().nullable();
export type NullableStringDto = z.infer<typeof NullableStringSchema>;

export const StringArraySchema = z.array(StringSchema);
export type StringArray = z.infer<typeof StringArraySchema>;

export const MessageResponseDtoSchema = z.object({
  message: z.string(),
});
export type MessageResponseDto = z.infer<typeof MessageResponseDtoSchema>;

export const SuccessResponseDtoSchema = z.object({
  success: z.boolean(),
});
export type SuccessResponseDto = z.infer<typeof SuccessResponseDtoSchema>;

export const VoidResponseDtoSchema = z.void();
export type VoidResponseDto = z.infer<typeof VoidResponseDtoSchema>;

export const BooleanSchema = z.boolean();
export type BooleanDto = z.infer<typeof BooleanSchema>;

export const NumberSchema = z.number();
export type NumberDto = z.infer<typeof NumberSchema>;

export const NumberArraySchema = z.array(NumberSchema);
export type NumberArray = z.infer<typeof NumberArraySchema>;
